import React, { useLayoutEffect, useRef } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import gsap from "gsap";

const services = [
  {
    number: "01",
    title: "Sustainable Manufacturing",
    text: "Efficient production methods designed to reduce environmental impact.",
  },
  {
    number: "02",
    title: "Innovation & Quality",
    text: "Technology-driven solutions built around reliability and continuous improvement.",
  },
  {
    number: "03",
    title: "Eco-Friendly Products",
    text: "Responsible products that help businesses move toward a greener future.",
  },
];

function About() {
  const heroRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        defaults: {
          ease: "power4.out",
        },
      });

      // Background elements
      gsap.from(".orb", {
        scale: 0,
        opacity: 0,
        duration: 1.8,
        stagger: 0.2,
        ease: "elastic.out(1, 0.6)",
      });

      // Main hero animation
      tl.from(".hero-eyebrow", {
        y: 30,
        opacity: 0,
        duration: 0.8,
      })
        .from(
          ".hero-title-line",
          {
            yPercent: 110,
            opacity: 0,
            duration: 1,
            stagger: 0.12,
          },
          "-=0.3"
        )
        .from(
          ".hero-description",
          {
            y: 30,
            opacity: 0,
            duration: 0.8,
          },
          "-=0.5"
        )
        .from(
          ".hero-buttons",
          {
            y: 25,
            opacity: 0,
            duration: 0.7,
          },
          "-=0.4"
        )
        .from(
          ".service-card",
          {
            y: 60,
            opacity: 0,
            scale: 0.96,
            duration: 0.7,
            stagger: 0.12,
          },
          "-=0.2"
        )
        .from(
          ".visual-ring",
          {
            scale: 0,
            rotation: -90,
            opacity: 0,
            duration: 1.4,
            ease: "elastic.out(1, 0.5)",
          },
          "-=1"
        );

      // Floating animation
      gsap.to(".orb-1", {
        y: -25,
        x: 15,
        duration: 4,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });

      gsap.to(".orb-2", {
        y: 30,
        x: -20,
        duration: 5,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });

      gsap.to(".orb-3", {
        y: -20,
        duration: 3.5,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });

      // Rotating ring
      gsap.to(".visual-ring", {
        rotation: 360,
        duration: 25,
        repeat: -1,
        ease: "none",
      });

      // Interactive mouse movement
      const handleMouseMove = (event) => {
        const { innerWidth, innerHeight } = window;

        const x = (event.clientX / innerWidth - 0.5) * 20;
        const y = (event.clientY / innerHeight - 0.5) * 20;

        gsap.to(".hero-visual", {
          x,
          y,
          duration: 1.2,
          ease: "power3.out",
        });

        gsap.to(".hero-content", {
          x: -x * 0.2,
          y: -y * 0.2,
          duration: 1.2,
          ease: "power3.out",
        });
      };

      window.addEventListener("mousemove", handleMouseMove);

      return () => {
        window.removeEventListener("mousemove", handleMouseMove);
      };
    }, heroRef);

    return () => ctx.revert();
  }, []);

  return (
    <main ref={heroRef} className="hero-section">
      {/* Decorative background */}
      <div className="hero-grid" />
{/* 
      <div className="orb orb-1" />
      <div className="orb orb-2" />
      <div className="orb orb-3" /> */}

      <Container className="hero-container py-lg-5 px-lg-5" fluid>
        <Row className="align-items-center g-5 py-lg-5">
          {/* Left Content */}
          <Col lg={7}>
            <div className="hero-content">
              {/* <div className="hero-eyebrow">
                <span className="eyebrow-line" />
                MIDDLE EAST FACTORIES PVT. LTD.
              </div> */}

              <h1 className="hero-title">
                <span className="title-mask">
                  <span className="hero-title-line">
                    Sustainable Manufacturing.
                  </span>
                </span>

                <span className="title-mask ">
                  <span className="hero-title-line">
                    Responsible Solutions.
                  </span>
                </span>

                <span className="title-mask title-highlight">
                  <span className="hero-title-line">
                    Global Impact.
                  </span>
                </span>
              </h1>

              <p className="hero-description">
                Middle East Factories Pvt. Ltd. delivers environmentally
                responsible products and technologies that help businesses
                reduce their environmental footprint while improving
                operational efficiency.
              </p>

              {/* <div className="hero-buttons">
                <Button className="btn-primary-custom">
                  Discover Our Solutions
                  <span className="button-arrow">↗</span>
                </Button>

                <Button className="btn-outline-custom">
                  Explore Our Services
                </Button>
              </div> */}
            </div>
          </Col>

          {/* Right Visual */}
          <Col lg={5}>
            <div className="hero-visual">
              <div className="visual-ring ring-one" />
              <div className="visual-ring ring-two" />

              <div className="visual-center">
                <div className="center-icon">
                  <svg
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M50 82C50 82 20 63 20 38C20 22 33 12 47 19C51 21 50 27 50 27C50 27 49 21 53 19C67 12 80 22 80 38C80 63 50 82 50 82Z"
                      stroke="white"
                      strokeWidth="4"
                    />
                    <path
                      d="M50 27V72"
                      stroke="white"
                      strokeWidth="4"
                      strokeLinecap="round"
                    />
                    <path
                      d="M50 45L36 35"
                      stroke="white"
                      strokeWidth="4"
                      strokeLinecap="round"
                    />
                    <path
                      d="M50 55L65 43"
                      stroke="white"
                      strokeWidth="4"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>

                <span>SUSTAINABILITY</span>
              </div>

              <div className="floating-label label-one">
                <span className="label-dot" />
                Eco Innovation
              </div>

              <div className="floating-label label-two">
                <span className="label-dot" />
                Smart Manufacturing
              </div>
            </div>
          </Col>
        </Row>

        {/* Services */}
        {/* <div className="services-wrapper">
          <Row className="g-3">
            {services.map((service) => (
              <Col md={4} key={service.number}>
                <div className="service-card">
                  
                  <h2>{service.title}</h2>

                  <p>{service.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div> */}
      </Container>
    </main>
  );
}

export default About;